export {
  FinanceOffersCarouselReference,
  type FinanceOffersCarouselReferenceProps,
} from './finance-offers-carousel-reference'
